import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils } from 'versafleet-core';
import { connect } from 'react-redux';

class MobileHeader extends React.Component {
  _renderMenuButton() {
    return (
      <Components.Button
        iconClassName="versa-menu"
        id={`${this.props.id}__menu`}
        onClick={() => Utils.MenuManager.openMenu()}
        showShadow={false}
      >
        {this.props.newCount > 0 ? <span className="vf-mobile-header__notification-dot" /> : false}
      </Components.Button>
    );
  }

  _renderTag() {
    return (
      <div
        className="vf-mobile-header__tag"
        id={`${this.props.id}__model-toggle`}
        onClick={this.props.onTagClick}
      >
        <span className="vf-mobile-header__tag__item">
          {this.props.tag}
        </span>
      </div>
    );
  }

  _renderFilterButton() {
    return (
      <Components.Button
        iconClassName="versa-refine"
        id={`${this.props.id}__filter-button`}
        onClick={this.props.onFilterClick}
        showShadow={false}
      />
    );
  }

  _renderSearchButton() {
    return (
      <Components.Button
        iconClassName="versa-search"
        id={`${this.props.id}__search-button`}
        onClick={(e) => { Utils.SearchManager.openSearch(); e.preventDefault(); }}
        showShadow={false}
      />
    );
  }

  render() {
    return (
      <div className="vf-mobile-header">
        {this._renderMenuButton()}
        {this.props.title}
        {this.props.onTagClick ? this._renderTag() : false}
        {this.props.onFilterClick ? this._renderFilterButton() : false}
        {this.props.shouldRenderSearch ? this._renderSearchButton() : false}
      </div>
    );
  }
}

MobileHeader.displayName = 'Mobile Header';

MobileHeader.propTypes = {
  id: PropTypes.string.isRequired,
  newCount: PropTypes.number,
  onFilterClick: PropTypes.func,
  onTagClick: PropTypes.func,
  shouldRenderSearch: PropTypes.bool,
  tag: PropTypes.string,
  title: PropTypes.string,
};

MobileHeader.defaultProps = {
  newCount: 0,
  onFilterClick: null,
  onTagClick: null,
  tag: null,
  title: 'MyJobs',
  shouldRenderSearch: true,
};

const mapStateToProps = (state) => {
  const { notification } = state;
  return {
    newCount: notification.newCount,
  };
};

export default connect(mapStateToProps)(MobileHeader);
